<template>
  <transition name="modal">
    <div class="modal-mask">
      <div id="mask" class="modal-wrapper" @click="closeDialog">
        <div class="modal-container">
          <div class="modal-header">
            Retype infobit
          </div>
          <div class="modal-body">
            <ul>
              <li v-for="(typeDef, type) in typeDefs">
                <label :for="typeDef.uri" class="clickable">
                  <input :id="typeDef.uri" type="radio" v-model="infobitType" :value="type">
                  {{typeDef.name}}
                </label>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button id="ok" class="clickable" @click="buttonHandler">
              <span class="fa fa-fw fa-check"></span>
              Ok
            </button>
            <button id="cancel" class="clickable cancel-button" @click="buttonHandler">
             <span class="fa fa-fw fa-close"></span>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
export default {

  props: ['infobit'],

  data: function () {
    return {
      infobitType: this.infobit.type
    }
  },

  computed: {
    typeDefs () {
      return this.$store.state.typeDefs
    }
  },

  methods: {
    buttonHandler (event) {
      event.stopPropagation()
      if (event.target.id === 'ok') {
        if (this.infobit.type !== this.infobitType) {
          this.$store.dispatch('retypeInfobit', {
            infobitId: this.infobit.id,
            infobitType: this.infobitType
          })
        }
      }
      this.$emit('input', false)
    },
    closeDialog (event) {
      if (event.target.id === 'mask') {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-container .cancel-button {
  margin-left: 1em;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-body ul {
  list-style-type: none;
}

.modal-footer {
  margin-bottom: 1em;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// retype-dialog.vue?a19efb12